import {match, Pattern} from 'ts-pattern';

import type {CustomerMessageResponseBody} from '@dms/api/core';
import {customerRoutes} from '@dms/routes';

import {composePath} from 'shared/web';

import type {CustomerInsightsLastContact} from '../types/CustomerInsightsViewModel';

const MAX_PREVIEW_LENGTH = 160;

const normalizePreview = (value: string) =>
  value
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

const truncatePreview = (value: string) =>
  value.length <= MAX_PREVIEW_LENGTH
    ? value
    : `${value.slice(0, MAX_PREVIEW_LENGTH - 1).trimEnd()}…`;

const getPreview = (message: CustomerMessageResponseBody) => {
  const source = message.channel === 'email' ? message.subject || message.content : message.content;
  const normalized = normalizePreview(source);

  return normalized.length > 0 ? truncatePreview(normalized) : undefined;
};

export const mapLastContact = (
  message: CustomerMessageResponseBody | undefined,
  customerId: string
): CustomerInsightsLastContact | undefined =>
  match(message)
    .with(undefined, () => undefined)
    .with(Pattern.nonNullable, (availableMessage) => ({
      occurredAt: availableMessage.createdAt,
      channel: availableMessage.channel,
      direction: availableMessage.direction,
      preview: getPreview(availableMessage),
      href: composePath(customerRoutes.communication, {params: {id: customerId}}),
    }))
    .exhaustive();
